var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.$props.isEnabled==true)?_c('div',[(_vm.$props.isLicensed)?_c('div',{staticClass:"plan-label pro"},[_vm._v(_vm._s(_vm.$t('lbl_license_yes')))]):(_vm.$props.isLicensed != null)?_c('div',{staticClass:"plan-label demo"},[_vm._v(_vm._s(_vm.$t('lbl_license_no')))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }